import { render, staticRenderFns } from "./HospitalizationForm.vue?vue&type=template&id=2b280604"
import script from "./HospitalizationForm.vue?vue&type=script&lang=js"
export * from "./HospitalizationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports